import React, { memo } from 'react';
import { TypographyH4, TypographyMuted } from '../Typography';
import styles from './StatCard.module.css';

/**
 * StatCard - minimal text-only stat tile.
 *
 * Props: title, value, subtitle, isLoading.
 * Other props historically accepted (icon, trend, color, index) are
 * intentionally ignored — the card is text-only by design.
 *
 * Text uses the 2.0 Typography components: title → TypographyH4 (keeps the
 * heading role consumers/tests rely on), subtitle → TypographyMuted. The value
 * stays a display figure (no Typography component represents a large stat number).
 */
const StatCard = memo(({ title, value, subtitle, isLoading }) => (
  <div className={styles.statCard}>
    <div className={styles.value}>{isLoading ? '—' : value}</div>
    <TypographyH4>{title}</TypographyH4>
    {subtitle && <TypographyMuted>{subtitle}</TypographyMuted>}
  </div>
));

StatCard.displayName = 'StatCard';

export default StatCard;
